<template>
  <div class="relative z-50 w-full overflow-hidden rounded-3xl bg-white px-2 py-10 md:px-10 md:py-[60px]">
    <slot />
  </div>
</template>
